import React from 'react';
import { Icon } from 'legacy-packages/ft-cb';
import RichText from 'legacy-src/utility/RichText';
import './styles.scss';

const FeedbackReader = ({ text, title }) =>
  text ? (
    <div className="feedback--reader">
      <div className="feedback--reader--container">
        <div className="feedback--reader--header">
          <Icon name="feedback-bubble" />
          <cite>{title}</cite>
        </div>
        <blockquote>
          <RichText content={text} />
        </blockquote>
      </div>
    </div>
  ) : null;

export default FeedbackReader;
